import React from 'react';
import Link from '../../Global/Link/Link';

import './styles.scss';

const VacancyCard = ({ vacancy }) => {
  const { name, location } = vacancy;

  return (
    <article className="vacancy-card">
      <Link to={vacancy}>
        <div>
          <p>{location}</p>
          <h2>{name}</h2>
        </div>

        <span>Read more and apply→</span>
      </Link>
    </article>
  );
};

export default VacancyCard;
